/**
 * Sibling reveal stagger (motion spec §5.3, DESIGN.md "Motion & Reveal"):
 * 60–80ms between staggered siblings, at most five staggered items, the
 * remainder arrives together with the fifth.
 */
export const STAGGER_MS = 70;
export const STAGGER_MAX_ITEMS = 5;

/** Animation delay for the `index`-th sibling, optionally after a base offset. */
export function staggerDelay(index: number, baseMs = 0): string {
  const step = Math.max(0, Math.min(index, STAGGER_MAX_ITEMS - 1));
  return `${step * STAGGER_MS + baseMs}ms`;
}
